/*jshint unused:false*/
/*global fetch */
/*global console */

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  //preloader
  let root = document.getElementsByTagName('html')[0];
  root.classList.add("site-loaded");
  document.body.classList.add("loaded");

    loadSearchForm();

});

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}

let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');
const hamburgerSearch = document.querySelector('#headerSearch');

const modalMobileNav = new tingle.modal({
  footer: true,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed'],
  onOpen: function () {
    // Navigation height
    let headerHeight = 0;
    if (document.querySelector('.site-header').classList.contains('is-sticky')) {
      headerHeight = document.querySelector('.site-header').offsetHeight;
    } else {
      headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
    }
    document.querySelector('.mobile-nav.tingle-modal').style.marginTop = headerHeight + 'px';
    document.querySelector('.mobile-nav.tingle-modal').style.height = `calc(100vh - ${headerHeight}px)`;
    priceToggles();
  }
});
document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML) : null;
document.querySelector('.site-menu') ? modalMobileNav.setFooterContent(document.querySelector('#price-switch').outerHTML) : null;

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');
  // hamburger.parentElement.classList.toggle('active');

  if(hamburger.classList.contains("active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

// Sticky class for navbar & modal
window.onscroll = function() {stickyNav()};
let navbar = document.getElementById('navbar');
let tingleModal = document.querySelector('.tingle-modal');
let sticky = navbar.offsetTop;
function stickyNav() {
  if (!document.body.classList.contains('tingle-enabled')) {
    if (window.pageYOffset+20 >= sticky) {
      navbar.classList.add('is-sticky')
      tingleModal.classList.add('is-sticky')
    } else {
      navbar.classList.remove('is-sticky')
      tingleModal.classList.remove('is-sticky')
    }
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */

// Price toggles
function priceToggles() {
  let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
  let priceSwitchForm = document.getElementById('price-switch');
  let selected;
  allSwitches.forEach((value) => {
    // value.addEventListener('click', (e) => {
    //
    // });
    value.addEventListener('change', (val) => {
      (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
      if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
        (val.target.checked === true) ? selected = 1 : selected = 0;
      }
      toggleSwitches();
      togglePrices();
      updatePrice();
    })
  })
  let toggleSwitches = () => {
    allSwitches.forEach((v) => {
      (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
      (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
    })
    document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
    document.querySelectorAll(".price-title-type").forEach((v) => {
      v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
    })
  }
  let togglePrices = () => {
    document.querySelectorAll('.deal-price-toggle').forEach((v) => {
      (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
      (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
    })
  }
  let updatePrice = () => {
    let url = priceSwitchForm.getAttribute('action');
    let formData = new FormData(priceSwitchForm);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
      function(response) {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then(function(data) {
          if(typeof love_electric_view != "undefined") {
            location.reload(); // Refresh the page
          }
          document.querySelector("#price-switch [name=_token]").value = data.token;
        });
      }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }
}
priceToggles();
// End price Toggles

// Toggle search bar
document.querySelector('#search-bar:not(.header-search)') ? document.querySelectorAll('.toggle-search:not([href="#search-bar"]), .toggle-search-mobile:not([href="#search-bar"])').forEach((value => {
  value.addEventListener('click', () => {
    document.querySelector('#search-bar').classList.toggle('active');
    document.querySelectorAll(".dropdown-menu > a, .dropdown-menu > .dropdown").forEach(value => {
      value.classList.remove("active");
      value.classList.remove("is-active");
    })
    if (value.classList.contains('toggle-search-mobile')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  })
})) : null;

// Toggle loader when searching
document.querySelector('.search-button') ? [].slice.call(document.querySelectorAll('.search-button')).forEach((value) => {
  value.addEventListener('click', () => {
    document.body.classList.remove('loaded')
  })
}) : null;

//Dropdown Menu Toggle
var showMenu = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode.querySelector('div');
    var menuToggle = this;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        menuToggle.classList.toggle("active");
        dropdown.classList.toggle("is-active");
        menuToggle.classList.toggle("is-active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".dropdown-menu .active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
          activeClass[i].classList.toggle("is-active");
        }
    }

    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("active");
    menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}

//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
	e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}

/**
  * SEARCH
  */
function searchType(elem, searchType) {
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  loadManufacturers(document.querySelector('#search-type').value);
  loadBodyTypes(document.querySelector('#search-type').value);

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;
}

function loadManufacturers($type) {
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/manufacturers';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
      }
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer) {
  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($manufacturer) {
      var url = '/api/' + $type + '/models/' + $manufacturer;
      if(window.location.pathname.includes('/used-evs')) {
        url = '/api/used-evs/models/' + $manufacturer;
      }

      fetch(url).then(function (response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function (data) {
        let keysSorted = Object.keys(data).sort(function (a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function (err) {
        console.error('Fetch Error -', err);
      });
    }
  }
}

function loadBodyTypes($type) {
  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Bodytype';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types';

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    for (var x in data) {
        var option = document.createElement('option');
        option.text = data[x];
        option.value = x;
        dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });
}

function loadSpecs($type, $model) {

  var dropdown = document.getElementsByName('spec_level')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Spec';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  if ($type && $model) {
    let url = '/api/'+$type+'/specs/'+$model;

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      for (var x in data) {
        var option = document.createElement('option');
        option.text = data[x];
        option.value = x;
        dropdown.add(option);
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }

}

// Contact Form
if(document.getElementById('send-contact-form')){

  let button = document.querySelector('#send-contact-form');
  let terms = document.querySelector('#contact-form [name=terms]');
  let creditCheck = document.querySelector('#contact-form [name=credit_check]');

  function toggleContactSubmitButton() {
    if (button && terms && creditCheck) {
      button.disabled = !(terms.checked && creditCheck.checked);
    }
  }

  if (terms && creditCheck) {
    terms.addEventListener('change', toggleContactSubmitButton);
    creditCheck.addEventListener('change', toggleContactSubmitButton);
  }

  let is_submitted = 0;

  document.getElementById('send-contact-form').addEventListener("click", function(e) {

    if (is_submitted === 1) {
      button.click();
    } else {

      e.preventDefault();

      // Do captcha and submit form
      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha;

          document.body.classList.remove('loaded');

          let url = '/contact';
          let email = document.querySelector('#contact-form [name=email]').value;
          let name = `${document.querySelector('#contact-form [name=forename]').value} ${document.querySelector('.contact-form [name=surname]').value}`;
          let forename = document.querySelector('#contact-form [name=forename]').value;
          let surname = document.querySelector('#contact-form [name=surname]').value;
          let telephone = document.querySelector('#contact-form [name=telephone]').value;
          let comments = document.querySelector('#contact-form [name=comments]').value;
          let source = document.querySelector('#contact-form [name=source]').value;
          let campaign = document.querySelector('#contact-form [name=campaign]').value;
          let token = document.querySelector('#contact-form [name=_token]').value;

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'name': name,
              'forename': forename,
              'surname': surname,
              'email': email,
              'telephone': telephone,
              'comments': comments,
              'source': source,
              'campaign': campaign,
              '_token': token,
              'g-recaptcha-response': recaptcha
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status!='ok'){
              $errors = '';
              for (var i in data.errors) {
                $errors += data.errors[i][0]+'\n';
              }
              return alert('There was a problem with your form\n\n'+$errors);
            }

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'General Enquiry Received'
            });

            // document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-form')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();
            // document.getElementsByClassName('contact-form')[0].submit();
            is_submitted = 1;
            button.click();

          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });

      });
    }
  });
}

// Map
if(document.getElementById('map')){

  let map_container = document.getElementById('map');
  let map_zoom = map_container.dataset.zoom;
  let map_lat_center = map_container.dataset.centerLat;
  let map_lng_center = map_container.dataset.centerLng;
  let map_lat = map_container.dataset.lat;
  let map_lng = map_container.dataset.lng;
  let map_lat_2 = map_container.dataset.lat2;
  let map_lng_2 = map_container.dataset.lng2;
  let map_lat_3 = map_container.dataset.lat3;
  let map_lng_3 = map_container.dataset.lng3;

  // Initialize and add the map
  function initMap() {
    var myOptions = {
      center: { lat: parseFloat(map_lat_center), lng: parseFloat(map_lng_center) },
      zoom: parseFloat(map_zoom),
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#7c93a3"
            },
            {
              "lightness": "-10"
            }
          ]
        },
        {
          "featureType": "administrative.country",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        },
        {
          "featureType": "administrative.country",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#c2d1d6"
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#dde3e3"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#c2d1d6"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#a9b4b8"
            },
            {
              "lightness": "0"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#a3c7df"
            }
          ]
        }
      ]
    };

    var map = new google.maps.Map( map_container, myOptions );
    if (map_lat && map_lng) {
      var marker = new google.maps.Marker({
        position: { lat: parseFloat(map_lat), lng: parseFloat(map_lng) },
        map: map,
        icon: { url: '/themes/carleasingpeople/img/logos/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
    if (map_lat_2 && map_lng_2) {
      var marker2 = new google.maps.Marker({
        position: { lat: parseFloat(map_lat_2), lng: parseFloat(map_lng_2) },
        map: map,
        icon: { url: '/themes/carleasingpeople/img/logos/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
    if (map_lat_3 && map_lng_3) {
      var marker3 = new google.maps.Marker({
        position: { lat: parseFloat(map_lat_3), lng: parseFloat(map_lng_3) },
        map: map,
        icon: { url: '/themes/carleasingpeople/img/logos/marker.svg', scaledSize: new google.maps.Size(100, 100) }
      });
    }
  }
}

// Subscribe Form
if(document.getElementById('email-signup')){
  document.getElementById('email-signup').addEventListener("click", function(e) {
    e.preventDefault();

    var recaptcha_token = null;

    if(document.querySelector('input[name=g-recaptcha-response]')){
      recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
    } else {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
        recaptcha_token = token;
      });
    }

    document.getElementById('email-signup').classList.add('preload');
    document.getElementById('email-signup').innerHTML = '<span class="btn-loading">Please wait<span>';
    document.getElementById('email-signup').disabled = true;

    let url = '/newsletter';
    let email = document.getElementById('newsletter-email').value;
    let name = document.getElementById('newsletter-name').value;
    let token = document.getElementsByName('_token')[0].value;

    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({ 'name': name, 'first_name': name, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }}).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;

      if(data.status!='ok'){
        let errors = '';
        for (var i in data.errors) {
          errors += data.errors[i][0]+'\n';
        }
        if(typeof Swal !== 'undefined'){
          return Swal.fire({
            title: 'Whoops!',
            html: ('There was a problem with your sign up details\n\n'+$errors).replace(/\n/gi,'<br>'),
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          return alert('There was a problem with your sign up details\n\n'+$errors);
        }
      }

      document.getElementsByClassName('newsletter-form')[0].reset();
      // Trigger event tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Newsletter Signup'
      });

      if(typeof Swal !== 'undefined'){
        return Swal.fire({
          title: 'Thank you!',
          text: 'You\'re signed up!',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        return alert('Thank you!');
      }

    }).catch(function(err) {
      console.error('Fetch Error -', err);
      document.getElementById('email-signup').classList.remove('preload');
      document.getElementById('email-signup').innerHTML = 'Signup';
      document.getElementById('email-signup').disabled = false;
    });
  });
}

const searchSorter = document.querySelector('#search-sorter');
if (searchSorter) {
  searchSorter.addEventListener('change', (e) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('order', e.target.value);
    window.location.search = urlParams;
  })
}
function loadSearchForm () {
  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){
    // Search
    if(typeof love_electric_view == "undefined") {
      let searchType
      (document.querySelector('#search-type')) ? searchType = document.querySelector('#search-type').value : searchType = document.querySelector('.quick-search [name=search-type]:checked').value;
      loadManufacturers(searchType);
       }
      document.querySelectorAll('.quick-search [name=search-type]').forEach((value => {
        value.addEventListener("change", function(e){
          loadManufacturers(this.value, e.target.value);
          loadModels(this.value, e.target.value);
          loadBodyTypes(this.value, e.target.value);
        });
      }))
 
    document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
      (document.querySelector('#search-type')) ? searchType = document.querySelector('#search-type').value : searchType = document.querySelector('.quick-search [name=search-type]:checked').value;
      loadModels(searchType, e.target.value);
      loadBodyTypes(searchType, e.target.value);
    });

    document.querySelector('.search-form [name=model]').addEventListener("change", function(e){
      (document.querySelector('#search-type')) ? searchType = document.querySelector('#search-type').value : searchType = document.querySelector('.quick-search [name=search-type]:checked').value;
      if (document.querySelector('.search-form [name=spec_level]')) {
        loadSpecs(searchType, e.target.value);
      }
    });
  }
}

// Deal Finder Strip
if (document.querySelector('#deal-finder-strip')) {
  function dealFinderSteps(el) {
    if (el.dataset.step !== '0') {
      el.parentElement.parentElement.classList.remove('active');
      document.querySelector(`.question[data-question="${el.dataset.step}"]`).classList.add('active');
    }
  }
  function dealFinder() {
    let dealFinderSubmit = document.querySelector('.deal-finder-submit');
    let dealFinderUrl = new URL(window.location.origin + '/search');
    dealFinderUrl.searchParams.append("search-type", "car");
    dealFinderSubmit.setAttribute('href', dealFinderUrl.href);

    document.querySelector('.deal-finder').reset();
    document.querySelectorAll('.deal-finder .question').forEach((value) => {
      value.classList.remove('active');
    });
    document.querySelector(`.question[data-question="1"]`).classList.add('active');
    dealFinderSubmit.classList.add('disabled');

    // Deal Finder - Bodytype Switch
    document.querySelectorAll('#bodytype-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        dealFinderUrl.searchParams.delete("body_type[]");
        dealFinderUrl.searchParams.set("body_type", e.target.value);
        dealFinderSubmit.setAttribute('href', dealFinderUrl.href);
      })
    })
    // Deal Finder - Fuel Type Switch
    document.querySelectorAll('#fuel-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        dealFinderUrl.searchParams.delete("fuel_type[]");
        dealFinderUrl.searchParams.set("fuel_type", e.target.value);
        dealFinderSubmit.setAttribute('href', dealFinderUrl.href);
      })
    })
    // Deal Finder - Transmission Switch
    document.querySelectorAll('#transmission-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        dealFinderUrl.searchParams.delete("transmission[]");
        dealFinderUrl.searchParams.set("transmission", e.target.value);
        dealFinderSubmit.setAttribute('href', dealFinderUrl.href);
      })
    })
    // Deal Finder - Budget Switch
    document.querySelectorAll('#budget-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        dealFinderUrl.searchParams.delete("budget[]");
        dealFinderUrl.searchParams.set("budget", e.target.value);
        dealFinderSubmit.setAttribute('href', dealFinderUrl.href);
      })
    })
    // Deal Finder - Initial Profile Switch
    document.querySelectorAll('#initial-profile-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        dealFinderUrl.searchParams.delete("initial_profile[]");
        dealFinderUrl.searchParams.set("initial_profile", e.target.value);
        dealFinderSubmit.setAttribute('href', dealFinderUrl.href);
      })
    })
    // Deal Finder - Term Switch
    document.querySelectorAll('#term-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        dealFinderUrl.searchParams.delete("term[]");
        dealFinderUrl.searchParams.set("term", e.target.value);
        dealFinderSubmit.setAttribute('href', dealFinderUrl.href);
      })
    })
    // Deal Finder - Mileage Switch
    document.querySelectorAll('#mileage-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        dealFinderUrl.searchParams.delete("mileage[]");
        dealFinderUrl.searchParams.set("mileage", e.target.value);
        dealFinderSubmit.setAttribute('href', dealFinderUrl.href);
      })
    })
    // Deal Finder - Type Switch
    document.querySelectorAll('#type-switch input').forEach((value) => {
      value.addEventListener('change', (e) => {
        dealFinderUrl.searchParams.delete("type[]");
        dealFinderUrl.searchParams.set("type", e.target.value);
        dealFinderSubmit.setAttribute('href', dealFinderUrl.href);
        dealFinderSubmit.classList.remove('disabled');
      })
    })
  }
  dealFinder();
}

document.addEventListener('DOMContentLoaded', () => {
  //Lazy Load Images
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;
  const lazyLoad = function() {
    if (active === false) {
      active = true;

      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });
      active = false;
    }
  };
  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();

  // Advanced Search
  document.getElementById('toggleAdvanced') ? document.getElementById('toggleAdvanced').addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector('.form select[name="budget"]').selectedIndex = 0;
    document.getElementById('search-bar').classList.toggle('search-advanced');
  }) : null;
  // let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  // if ( width < 480 ) {
  //   document.getElementById('search-bar').classList.remove('search-advanced');
  // }

  // Search Sidebar
  let filterSwitch = document.querySelectorAll('.filter-switch');
  if(filterSwitch){
    Array.prototype.slice.call(filterSwitch, 0).forEach((value) => {
      value.addEventListener('click', () => {
        document.querySelector('#page').classList.toggle('closed');
        document.querySelector('.search-results-filters').classList.toggle('closed');
        // document.querySelector('.search-results-filters-switch').classList.toggle('open');
      })
    })
  }
  let breadcrumbsSwitch = document.querySelector('.breadcrumbs-search.filter-switch');
  if (breadcrumbsSwitch){
    document.querySelector('#page').classList.add('has-search');
  }
  let searchPage = document.querySelector('.breadcrumbs.search-page');
  if (searchPage){
    document.querySelector('#page').classList.add('search-page');
  }
  // END Search Sidebar

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1960,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }

  // Deal Box Slider
  const dealBoxSlider = [].slice.call(document.querySelectorAll('.offers-strip:not(.derivative-page) .offers-strip-ctr'))
  if (dealBoxSlider) {
    dealBoxSlider.forEach((e) => {
      let sliderID = e.parentElement.parentElement.getAttribute('id')
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        dots: '.offers-strip .dots',
        arrows: {
          prev: '.offers-strip .glider-prev',
          next: '.offers-strip .glider-next'
        },
        responsive: [
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      })
    })
  }

  // Reviews Slider
  // const reviewsSlider = [].slice.call(document.querySelectorAll('.reviews-strip-grid'))
  // if (reviewsSlider) {
  //   reviewsSlider.forEach((e) => {
  //     let sliderID = e.parentElement.parentElement.getAttribute('id')
  //     new Glider(e, {
  //       slidesToScroll: 1,
  //       slidesToShow: 1,
  //       // draggable: true,
  //       // scrollLock: true,
  //       // dots: '.reviews-strip-grid .dots',
  //       // arrows: {
  //       //   prev: '.reviews-strip-grid .glider-prev',
  //       //   next: '.reviews-strip-grid .glider-next'
  //       // },
  //       responsive: [
  //         {
  //           breakpoint: 959,
  //           settings: {
  //             slidesToShow: 2,
  //           }
  //         },
  //         {
  //           breakpoint: 1440,
  //           settings: {
  //             slidesToShow: 3,
  //           }
  //         }
  //       ]
  //     })
  //   })
  // }

  // Toggle class for accordions
  let acc = document.getElementsByClassName('mobile-accordion-header');
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(ev) {

      for (let i = 0; i < acc.length; i++) {
        if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
          continue;
        }
        acc[i].parentElement.classList.remove('active');
      }

      if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
        setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
      }
      this.parentElement.classList.toggle("active");

    });
  }

  // Close modals on orientation changes
  window.addEventListener("orientationchange", function() {
    modalMobileNav.close();
    // modalMobileSearch.close();
    // videoModal.close();
    // hamburgerSearch.classList.remove('is-active');
    hamburger.classList.remove('is-active');
    navContainer.classList.remove('is-active');
  }, false);

  // Model Table Search
  let allRows = document.querySelectorAll('.model-table-body > .model-table-wrapper');
  let filterFields = document.querySelectorAll('.model-table-head select');
  let transmission_types = [];
  let fuel_types = [];
  const loadOptions = () => {
    allRows.forEach((row) => {
      (row.getAttribute('data-transmission')) ? transmission_types.push(row.getAttribute('data-transmission')) : '';
      transmission_types = [...new Set(transmission_types)];
      (row.getAttribute('data-fuel')) ? fuel_types.push(row.getAttribute('data-fuel')) : '';
      fuel_types = [...new Set(fuel_types)];
    })
    const loadSelectOptions = (type, array) => {
      array.forEach((v) => {
        let option = document.createElement("option");
        option.value = v;
        option.text = v;
        document.querySelector('select[name=' + type + ']').appendChild(option);
        fuel_types = [];
      })
    }
    loadSelectOptions('fuel_types', fuel_types);
    loadSelectOptions('transmission_types', transmission_types);
  }

  const filterTable = (field, value) => {
    let searchType;
    if (field === 'fuel_types') {
      searchType = 'fuel';
    } else if (field === 'transmission_types') {
      searchType = 'transmission';
    } else {
      searchType = field;
    }

    if (value !== '' && value.length > 0) {
      let elements = document.querySelectorAll('.model-table-row[data-' + searchType + ']');
      elements.forEach((v) => {
        v.classList.add('hidden-' + field + '')
        if(v.getAttribute('data-' + searchType + '').includes(value)) {
          v.classList.remove('hidden-' + field + '')
        }
      })
    } else {
      document.querySelectorAll('.model-table-row[data-' + searchType + ']').forEach((v) => {
        v.classList.remove('hidden-' + field + '')
      });
    }

    // Show no results text
    if(!document.querySelectorAll('.model-table-wrapper:not([class*="hidden"]):not(.no-results)').length > 0) {
      document.querySelector('.no-results').classList.remove('hidden-no-results', 'hidden');
    } else {
      document.querySelector('.no-results').classList.add('hidden-no-results');
    }

    // Fix rows background
    document.querySelectorAll('.model-table-wrapper:not([class*="hidden"])').forEach((v, i) => {
      v.classList.remove('even')
      if (i % 2 !== 0) {
        v.classList.add('even')
      }
    });
  }

  if (filterFields) {
    loadOptions();
    filterFields.forEach((value => {
      value.addEventListener('change', (event) => {
        let val = value.value;
        let field = value.getAttribute('name');
        filterTable(field, val);
      })
    }))
  }
  // End Model Table Search

  // Header - Show More
  const showMoreButton = document.querySelector('#show-more');
  const headerContent = document.querySelector('#manufacturer-header-content');
  if(showMoreButton){
    if (showMoreButton.parentElement.querySelectorAll('.header-description > p').length > 1) {
      showMoreButton.addEventListener('click', (e) => {
        headerContent.classList.toggle('header-content--full');
        showMoreButton.classList.toggle('active');
        (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show Less' : showMoreButton.querySelector('span').innerText = 'Read More';
      })
    } else {
      showMoreButton.classList.add('visuallyhidden')
    }
  }

  // Calculators
  if (document.querySelector('body').classList.contains('page-compare-vehicles')) {
    // Indicative Fuel Cost
    function indicativeCost($fuel_type = false, $mpg = null, $electric_range = null, $battery_size = null, $electricity_cost = null) {
      let indicativeCost;
      if ($fuel_type === 'Electric' && $electric_range && $battery_size){
        let electricity_cost = ($electricity_cost) ? $electricity_cost : document.getElementById('average-data').dataset.averageElectricity;
        let miles_per_kwh = $electric_range / $battery_size;
        let cost_per_mile = electricity_cost / miles_per_kwh;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type === 'Diesel' && $mpg) {
        let cost_per_litre_diesel = document.getElementById('average-data').dataset.averageDiesel;
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_diesel / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type !== false && $mpg) {
        let cost_per_litre_petrol = document.getElementById('average-data').dataset.averagePetrol;
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_petrol / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else {
        indicativeCost = 'N/A';
      }
      return indicativeCost;
    }
  }
  // Load Manufacturers Dropdown
  function loadManufacturersCalc() {
    var make_dropdowns = document.getElementsByName("calculator-make");
    for (i = 0; i < make_dropdowns.length; i++) {

      var dropdown = make_dropdowns[0];
      dropdown.length = 0;

      var defaultOption = document.createElement('option');
      defaultOption.text = 'Select Manufacturer';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      var url = '/api/car/manufacturers/ev';

      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }
  // Load Models Dropdown
  function loadModelsCalc($type, $manufacturer, $ev = true, $inactive = false, $compare = false) {
    let model_dropdowns, derivative_dropdowns;
    ($compare) ? model_dropdowns = document.getElementsByName("calculator-model-compare") : model_dropdowns = document.getElementsByName("calculator-model");
    ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
    for (let i = 0; i < derivative_dropdowns.length; i++) {
      let dropdown = derivative_dropdowns[i];
      dropdown.length = 0;
      let defaultOption = document.createElement('option');
      defaultOption.text = 'Select Variant';
      defaultOption.value = '';
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;
    }
    for (let i = 0; i < model_dropdowns.length; i++) {
      let dropdown = model_dropdowns[i];
      dropdown.length = 0;

      let defaultOption = document.createElement('option');
      defaultOption.text = 'Select Model';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      let url;
      ($ev) ? url = '/api/' + $type + '/models/' + $manufacturer + '/ev' : url = '/api/' + $type + '/models/' + $manufacturer;

      let params;
      ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '';

      fetch(url + params).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }
  // Load Derivatives Dropdown
  function loadDerivativeCalc($type, $model, $default = false, $ev = true, $inactive = false, $compare = false) {
    let derivative_dropdowns;
    ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
    for (let i = 0; i < derivative_dropdowns.length; i++) {
      let dropdown = derivative_dropdowns[i];
      dropdown.length = 0;

      if ($default){
        let defaultOption = document.createElement('option');
        defaultOption.text = 'Select Variant';
        defaultOption.value = '';

        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
      }

      let url;
      ($ev) ? url = '/api/' + $type + '/derivatives/' + $model + '/ev' : url = '/api/' + $type + '/derivatives/' + $model;

      let params;
      if($compare) {
        ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive', 'compare_ev': 'true'}) : params = '';
      } else {
        ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '';
      }

      fetch(url + params).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          if (x === '2813'){ continue }
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  }

  // Compare Vehicles
  if (document.querySelector('body').classList.contains('page-compare-vehicles')) {
    let comparisonTable = document.getElementById('car-comparison')
    let makeField = document.querySelector('select[name=calculator-make]')
    let modelField = document.querySelector('select[name=calculator-model]')
    let derivativeField = document.querySelector('select[name=calculator-derivative]')

    function compareColumns(row, reverse = false, blue = false) {
      let largest = 0
      let smallest = 9999
      comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
        if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
          (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
          (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
          comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
          if(largest !== smallest) {
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
          }
        }
      })
    }

    function loadVehicle($spot, $derivative) {
      if ($derivative !== 0) {
        let url = '/api/car/' + $derivative;
        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          let getCapTechnicalData;
          if(data.car.technical) {
            getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
          } else {
            getCapTechnicalData = ($category, $term) => 'N/A';
          }
          comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

          comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
          comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] .derivative`).innerText = data.car.name;
          (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta_top"] [data-car=${$spot}] a`).classList.add('visuallyhidden');
          (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="model"] [data-car=${$spot}] a`).classList.add('visuallyhidden');
          comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img);

          comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + (parseFloat(data.car.base_price)).toFixed(0) : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
          (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
          compareColumns('electric-range');
          comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
          (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
          compareColumns('real-electric-range');

          comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
          (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
          compareColumns('official-mpg');
          comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max') && getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
          (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
          compareColumns('real-mpg');

          let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
          comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
          (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
          compareColumns('indicative-cost', true);

          // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
          // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
          comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? data.car.co2 + ' g/km' : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions') && getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
          // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
          // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

          if (data.car.tax_band) {
            comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
            (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
            compareColumns('first-year-rate', true);
            comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
            (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
            compareColumns('year-rate', true);
          }

          if (data.car.fuel_type === 'Petrol') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
          } else if (data.car.fuel_type === 'Diesel') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
          } else if (data.car.fuel_type === 'Electric') {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
          } else {
            comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
          }

          if (data.car.tax) {
            comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
            (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
            compareColumns('bik-1', true);
            comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
            (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
            compareColumns('bik-2', true);
            comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
            (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
            compareColumns('bik-3', true);
          }

          comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats') && getCapTechnicalData('Weight and Capacities', 'No. of Seats').value) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
          (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
          compareColumns('engine-size', false, true);
          comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
          comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
          comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP') && getCapTechnicalData('Performance', 'Engine Power - BHP').value) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
          (parseInt(getCapTechnicalData('Performance', 'Engine Power - BHP').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
          compareColumns('engine-power', false, true);
          comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
          (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
          compareColumns('acceleration', false, true);
          comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed') && getCapTechnicalData('Performance', 'Top Speed').value) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
          (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
          compareColumns('top-speed', false, true);
          if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
            for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
              let star = document.createElement("img");
              star.setAttribute('src', '/themes/carleasingpeople/img/icons/general/star-gold.svg');
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
            }
          } else {
            comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
          }
          comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group') && getCapTechnicalData('General', 'Insurance Group').value) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

          (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');

          ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');

          loadModelsCalc('car', 0, false, true)

          comparisonTable.reset();
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }

    makeField.addEventListener('change', () => {
      (makeField.value > 0) ? loadModelsCalc('car', makeField.value, false, false) : false;
    })

    modelField.addEventListener('change', () => {
      (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, true, false, true, false) : false;
      derivativeField.dataset.range = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
    });

    setTimeout(() => {
      (comparisonTable.dataset.carFirst > 1) ? loadVehicle('first', comparisonTable.dataset.carFirst) : null;
    }, 200);
    setTimeout(() => {
      (comparisonTable.dataset.carSecond > 1) ? loadVehicle('second', comparisonTable.dataset.carSecond) : null;
    }, 400);
    setTimeout(() => {
      if (comparisonTable.dataset.carThird > 1) {
        loadVehicle('third', comparisonTable.dataset.carThird);
        comparisonTable.setAttribute('data-car-form', '0');
      }
    }, 1000);

    derivativeField.addEventListener('change', (event) => {
      if(event.target.value > 0) {

        if(parseInt(comparisonTable.dataset.carFirst) < 1) {
          loadVehicle('first', event.target.value)
        } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
          loadVehicle('second', event.target.value)
        } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
          loadVehicle('third', event.target.value)
        } else { }

        let cookie = Cookies.get('compare_list')
        let range_name = derivativeField.dataset.range
        if (cookie) {
          let cookie_obj = JSON.parse(cookie);
          if (Object.keys(cookie_obj).length < 3) {
            if (cookie_obj[event.target.value] === undefined) {
              cookie_obj = {...cookie_obj, [event.target.value] : range_name};
              let cookie_string = JSON.stringify(cookie_obj)
              Cookies.set('compare_list', cookie_string)
            }
          }
        } else {
          let cookie_obj = JSON.parse(`{"${event.target.value}":"${range_name}"}`);
          let cookie_string = JSON.stringify(cookie_obj)
          Cookies.set('compare_list', cookie_string)
        }

      }
    })

    function resetSlot($slot, $id) {
      comparisonTable.setAttribute('data-car-form', '1');
      document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
      document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
      if ($slot === 'first') {
        comparisonTable.setAttribute('data-car-first', '-1');
      } else if ($slot === 'second') {
        comparisonTable.setAttribute('data-car-second', '-1');
      } else {
        comparisonTable.setAttribute('data-car-third', '-1');
      }

      let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
      [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
        if (index === 0) {
          (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
          (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
          (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
          let cookie = Cookies.get('compare_list');
          let cookie_obj = JSON.parse(cookie);
          delete cookie_obj[$id];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
        }
      })

    }
    document.querySelectorAll('.car-comparison-table-row--img>div[data-car] .reset').forEach(value => {
      value.addEventListener('click', evt => {
        comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
        (evt.target.classList.contains('first')) ? resetSlot('first', comparisonTable.dataset.carFirst) : null;
        (evt.target.classList.contains('second')) ? resetSlot('second', comparisonTable.dataset.carSecond) : null;
        (evt.target.classList.contains('third')) ? resetSlot('third', comparisonTable.dataset.carThird) : null;
      })
    })
  }
  // Add To Compare
  window.initializeDealActions = () => {
  document.querySelectorAll('button[data-compare]:not([data-actions-bound])').forEach((value) => {
    value.setAttribute('data-actions-bound', 'true');
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.currentTarget.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.currentTarget.dataset.compare] : e.currentTarget.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list', cookie_string)
            e.currentTarget.innerHTML = `<svg width="20" height="20"><use xlink:href="/themes/carleasingpeople/img/icons/minus-circle.svg#minus"></use></svg>&nbsp;<span>Compare</span>`;
            e.currentTarget.dataset.compareAdded = 'true';
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">${e.currentTarget.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2220\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/carleasingpeople/img/icons/plus-circle.svg#plus\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211.8\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/carleasingpeople/img/icons/plus-circle.svg#plus\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211.8\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/carleasingpeople/img/icons/plus-circle.svg#plus\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/car-comparison-tool" }
              });
          } else {
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">Car comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.currentTarget.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2220\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/carleasingpeople/img/icons/plus-circle.svg#plus\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2220\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/carleasingpeople/img/icons/plus-circle.svg#plus\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2220\\x22 height=\\x2220\\x22><use xlink:href=\\x22/themes/carleasingpeople/img/icons/plus-circle.svg#plus\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/car-comparison-tool" }
              });
          }
        } else {
          delete cookie_obj[e.currentTarget.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
          e.currentTarget.innerHTML = `<svg width="20" height="20"><use xlink:href="/themes/carleasingpeople/img/icons/plus-circle.svg#plus"></use></svg>&nbsp;<span>Compare</span>`;
          e.currentTarget.dataset.compareAdded = 'false';
          alertify.confirm('Car Comparison')
            .setting({
              'title': 'Car Comparison',
              'message': `<span class="semi-bold">${e.currentTarget.dataset.name}</span> removed from comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/car-comparison-tool" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.currentTarget.dataset.compare}":"${e.currentTarget.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list', cookie_string)
        e.currentTarget.innerHTML = `<svg width="20" height="20"><use xlink:href="/themes/carleasingpeople/img/icons/minus-circle.svg#minus"></use></svg>&nbsp;<span>Compare</span>`;
        e.currentTarget.dataset.compareAdded = 'true';

        alertify.confirm('Car Comparison')
          .setting({
            'title': 'Car Comparison',
            'message': `<span class="semi-bold">${e.currentTarget.dataset.name}</span> added to comparison`,
            'labels': { ok: 'Go To Compare', cancel: 'Close' },
            'onok': function(){ window.location.href = "/car-comparison-tool" }
          });
      }
    })
  })
  // Add To Favourites
  document.querySelectorAll('button[data-favourite]:not([data-actions-bound])').forEach((value) => {
    value.setAttribute('data-actions-bound', 'true');
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('favourite_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.currentTarget.dataset.favourite] === undefined) {
          if (Object.keys(cookie_obj).length < 30) {
            cookie_obj = {...cookie_obj, [e.currentTarget.dataset.favourite] : e.currentTarget.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('favourite_list', cookie_string)
            e.currentTarget.innerHTML = `<svg width="20" height="20"><use xlink:href="/themes/carleasingpeople/img/icons/heart-full.svg#heart"></use></svg>&nbsp;<span>Remove from favourites</span>`;
            e.currentTarget.dataset.favouriteAdded = 'true';
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">${e.currentTarget.dataset.name}</span> added to favourites
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/favourites" }
              });
          } else {
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">Favourites list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your favourites list add ${e.currentTarget.dataset.name} again.</span>
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/favourites" }
              });
          }
        } else {
          delete cookie_obj[e.currentTarget.dataset.favourite];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list');
          e.currentTarget.innerHTML = `<svg width="20" height="20"><use xlink:href="/themes/carleasingpeople/img/icons/heart.svg#heart"></use></svg>&nbsp;<span>Add to favourites</span>`;
          e.currentTarget.dataset.favouriteAdded = 'false';
          document.querySelector('.car-comparison') ? e.currentTarget.closest('.deal-box').remove() : null;
          alertify.confirm('Your Favourites')
            .setting({
              'title': 'Your Favourites',
              'message': `<span class="semi-bold">${e.currentTarget.dataset.name}</span> removed from favourites`,
              'labels': { ok: 'Go To Favourites', cancel: 'Close' },
              'onok': function(){ window.location.href = "/favourites" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.currentTarget.dataset.favourite}":"${e.currentTarget.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('favourite_list', cookie_string)
        e.currentTarget.innerHTML = `<svg width="20" height="20"><use xlink:href="/themes/carleasingpeople/img/icons/heart-full.svg#heart"></use></svg>&nbsp;<span>Remove from favourites</span>`;
        e.currentTarget.dataset.favouriteAdded = 'true';
        alertify.confirm('Your Favourites')
          .setting({
            'title': 'Your Favourites',
            'message': `<span class="semi-bold">${e.currentTarget.dataset.name}</span> added to favourites`,
            'labels': { ok: 'Go To Favourites', cancel: 'Close' },
            'onok': function(){ window.location.href = "/favourites" }
          });
      }
    })
  })
  };
  window.initializeDealActions();

  // Gauges
  if (document.querySelector('#charging-speeds')) {
    const gaugeOpts = {
      angle: -0.25, lineWidth: 0.18, radiusScale: 1, strokeColor: '#F2F3F3',
      generateGradient: true, highDpiSupport: true,
      pointer: { length: 0.58, strokeWidth: 0.04, color: '#2C363A' }
    }
    const gaugeHomeOpts = { colorStart: '#EEE354', colorStop: '#EBCF00'};
    const gaugeFastOpts = { colorStart: '#32E1CF', colorStop: '#32DDE1' };
    const gaugeRapidOpts = { colorStart: '#32E1C3', colorStop: '#32E18A' };
    const gaugeUltraOpts = { colorStart: '#FC4F23', colorStop: '#FC4F23' };

    function runGauge($target, $opts, $animationSpeed, $maxValue) {
      if ($target){
        let gauge = new Gauge($target).setOptions({...gaugeOpts, ...$opts});
        gauge.maxValue = $maxValue;
        gauge.setMinValue(0);
        gauge.animationSpeed = $animationSpeed;
        gauge.set(($maxValue - $target.dataset.minutes));
      }
    }

    function scrollAnimTriggerCheck() {
        runGauge(document.getElementById('gaugeHome'), gaugeHomeOpts, 500, 1440);
        runGauge(document.getElementById('gaugeFast'), gaugeFastOpts, 400, 1440);
        runGauge(document.getElementById('gaugeRapid'), gaugeRapidOpts, 300, 1440);
        runGauge(document.getElementById('gaugeUltra'), gaugeUltraOpts, 200, 1440);
    }
    document.getElementById('charging-info-tab').addEventListener("click", scrollAnimTriggerCheck);
  }

  // Search Derivative Specification
  if(document.querySelector('#specification-search')){
    let search = document.querySelector('#specification-search');
    let all_data = document.querySelectorAll('#technical-data li, #key-info li');
    let no_results = document.querySelector('#specification-search-results .no-results');
    let result_list = document.querySelector('#specification-search-results ul');
    search.addEventListener('focus', function(e) {
      document.querySelectorAll('.tab-content, .tab').forEach(value => { value.classList.remove('active') });
      document.querySelector('#specification-search-results').classList.add('active');
    });
    search.addEventListener('input', function(e) {
      if (e.target.value !== '') {
        result_list.innerHTML = '';
        no_results.classList.add('visuallyhidden');
        let i = 0;
        all_data.forEach((value ) => {
          if(value.textContent.toLowerCase().includes(search.value.toLowerCase())) {
            i++;
            result_list.append(value.cloneNode(true));
          }
        })
        if (i < 1) {
          result_list.innerHTML = '';
          no_results.classList.remove('visuallyhidden');
        }
      } else {
        result_list.innerHTML = '';
        no_results.classList.remove('visuallyhidden');
      }
    });
  }
});
